import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { Bar } from 'react-chartjs-2'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import NoData from 'components/common/NoData/NoData'
import WidgetContainer from 'components/Apps/WidgetContainer'
import * as COLOR from 'constants/colors'
import messages from '../translate'

class TotalBarriosSeaLice extends Component {
  getBarrioData = () => {
    const {
      activeBarrio,
      intl: { formatMessage },
    } = this.props
    const sitesData = this.props.sitesData.toArray()
    const sites = []
    const labels = []
    const juvenileArray = []
    const mobileAdultsArray = []
    const gravidFemalesArray = []
    const backgroundColorGravidFemales = []

    for (const key in sitesData) {
      if (sitesData.hasOwnProperty(key)) {
        const site = sitesData[key]
        const weeksData = site.weeks[site.weeks.length - 1]

        if (site.neighborhood_id !== activeBarrio) continue

        sites.push({
          label: site.site_name ? site.site_name : site.siep,
          juveniles: weeksData.juveniles,
          mobile_adult: weeksData.mobile_adult,
          pregnant_female: weeksData.pregnant_female,
        })
      }
    }

    for (const key in sites) {
      if (sites.hasOwnProperty(key)) {
        const site = sites[key]
        labels.push(site.label)
        juvenileArray.push(site.juveniles)
        mobileAdultsArray.push(site.mobile_adult)
        gravidFemalesArray.push(site.pregnant_female)
        backgroundColorGravidFemales.push(
          site.pregnant_female < 3 ? COLOR.RAW_ASPHALT : COLOR.DELICATE_PINK,
        )
      }
    }

    return {
      datasets: [
        {
          backgroundColor: backgroundColorGravidFemales,
          data: gravidFemalesArray,
          label: formatMessage(messages.gravidFemales),
        },
        {
          backgroundColor: COLOR.CLEAN_SKY,
          data: mobileAdultsArray,
          label: formatMessage(messages.mobileAdults),
        },
        {
          backgroundColor: COLOR.LIGHT_GRAY,
          data: juvenileArray,
          label: formatMessage(messages.juvenile),
        },
      ],
      labels,
    }
  }

  optionData = () => ({
    aspectRatio: ifWindowWidthLessThan(768) ? 1.25 : 2.5,
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
          },
        },
      ],
    },
    plugins: {
      datalabels: {
        display: false,
      },
    },
  })

  getUnitName = () => {
    const barriosList = this.props.barriosList.toArray()
    for (const k in barriosList) {
      if (
        barriosList.hasOwnProperty(k) &&
        barriosList[k].id === this.props.activeBarrio
      ) {
        return barriosList[k].name
      }
    }

    return null
  }

  render() {
    const {
      sitesData,
      intl: { formatMessage },
    } = this.props

    if (sitesData.size === 0) return <NoData />

    return (
      <WidgetContainer
        name={{
          start: formatMessage(messages.sitesOf),
          end: this.getUnitName(),
        }}>
        <div className="chart-container">
          <Bar
            width={null}
            height={null}
            data={this.getBarrioData()}
            options={this.optionData()}
            datasetKeyProvider={() => Math.random()}
          />
        </div>
      </WidgetContainer>
    )
  }
}

export default connect(
  state => ({
    sitesData: state.getIn(['seaLice', 'sitesData']),
    barriosList: state.getIn(['seaLice', 'barriosList']),
    activeBarrio: state.getIn(['seaLice', 'activeBarrios']),
  }),
  null,
)(injectIntl(TotalBarriosSeaLice))
